module.exports = __webpack_public_path__ + "static/fonts/gothammedium.fe93c56.woff";